
export function filterObjectByType<T extends object>(obj: T, template: Partial<T>): Partial<T> {
    const result = {} as Partial<T>;

    for (const key of Object.keys(template) as (keyof T)[]) {
        if (key in obj) {
            const value = obj[key];
            const templateValue = template[key];

            if (
                typeof templateValue === "object" &&
                templateValue !== null &&
                typeof value === "object" &&
                value !== null
            ) {
                result[key] = filterObjectByType(value, templateValue) as T[keyof T];
            } else {
                result[key] = value;
            }
        }
    }

    return result;
}

// Nuevo enfoque: Usar una plantilla estática basada en un tipo
export function filterObjectByInterface<T extends object>(obj: any, template: Partial<T>): Partial<T> {
    return filterObjectByType(obj, template);
}